function generateBedGrateUpsell() {
  if ($('#upsell-rost').length) {
    var grateLameloveUrl = '#upsell-rost';
    var grateLatoveUrl = '#upsell-rost';
    var matracesUrl = '#upsell-rost';
    switch(lang) {
      case 'sk':
        var upsellGrateHeadline = 'K tejto posteli odporúčame dokúpiť';
        var grateLameloveText = 'Lamelový rošt';
        var grateLatoveText = 'Latovy rošt';
        var matracesText = 'Matrac';
        break;
      case 'hu':
        var upsellGrateHeadline = 'Az ágyhoz ajánljuk hozzávásárolni';
        var grateLameloveText = 'Lamellás ágyrács';
        var grateLatoveText = 'Léces ágyrács';
        var matracesText = 'Matrac';
        break;
      case 'cs':
        var upsellGrateHeadline = 'K této posteli doporučujeme zakoupit';
        var grateLameloveText = 'Lamelový rošt';
        var grateLatoveText = 'Latovy rošt';
        var matracesText = 'Matrace';
        break;
      case 'ro':
        var upsellGrateHeadline = 'La acest pat, recomandăm să achiziționați';
        var grateLameloveText = 'Somieră lamelară';
        var grateLatoveText = 'Somieră cu șipci';
        var matracesText = 'Saltea';
        break;
      case 'bg':
        var upsellGrateHeadline = 'K tejto posteli odporúčame dokúpiť';
        var grateLameloveText = 'Lamelový rošt';
        var grateLatoveText = 'Latovy rošt';
        var matracesText = 'Matrac';
        break;
      case 'hr':
        var upsellGrateHeadline = 'Preporučujemo kupiti uz ovaj krevet';
        var grateLameloveText = 'Lamelna podnica';
        var grateLatoveText = 'Letvičasta podnica';
        var matracesText = 'Madrac';
        break;
      case 'si':
        var upsellGrateHeadline = 'Za to posteljo priporočamo nakup';
        var grateLameloveText = 'Lamelno posteljno dno';
        var grateLatoveText = 'Letveno posteljno dno';
        var matracesText = 'Vzmetnica';
        break;
      case 'ua':
        var upsellGrateHeadline = 'K tejto posteli odporúčame dokúpiť';
        var grateLameloveText = 'Lamelový rošt';
        var grateLatoveText = 'Latovy rošt';
        var matracesText = 'Matrac';
        break;  
      default:
        return;
    }
    switch(shopName) {
      case 'wsk':
        var parameterSelector = "#parameter-id-245";
        break;
      case 'whu':
        var parameterSelector = "#parameter-id-245";
        break;
      case 'wcz':
        var parameterSelector = "#parameter-id-28";
        break;
      //testovaci e-shop
      case 'test':
        var parameterSelector = "#parameter-id-28";
        break;
      default:
        return;
    }

    var grateBox = '<div class="grate-box">' +
      '    <h2>' + upsellGrateHeadline + '</h2>' +
      '    <div class="options">' +
      '        <a href="' + grateLameloveUrl + '" class="option">' +
      '            <img src="https://cdn.myshoptet.com/usr/www.wilsondo.sk/user/documents/Scripty/images/icon_lamelovy-rost.jpg?v=2"/>' +
      '            <span>' + grateLameloveText + '</span>' +
      '        </a>' +
      '        <a href="' + grateLatoveUrl + '" class="option">' +
      '            <img src="https://cdn.myshoptet.com/usr/www.wilsondo.sk/user/documents/Scripty/images/icon_latovy-rost.jpg?v=2"/>' +
      '            <span>' + grateLatoveText + '</span>' +
      '        </a>' +
      '        <a href="' + matracesUrl + '" class="option">' +
      '            <img src="https://cdn.myshoptet.com/usr/www.wilsondo.sk/user/documents/Scripty/images/icon_matrac.jpg?v=2"/>' +
      '            <span>' + matracesText + '</span>' +
      '        </a>' +
      '    </div>' +
      '</div>';
    $(grateBox).insertBefore('.p-info-wrapper .social-buttons-wrapper');

    updateGrateDescription();

    $( `${parameterSelector}` ).change(function() {
      updateGrateDescription();
    });
  }
}

function updateGrateDescription() {
  switch(lang) {
    case 'sk':
      var variantText = "Variant: ";
      break;
    case 'hu':
      var variantText = "Változat: ";
      break;
    case 'cs':
      var variantText = "Varianta: ";
      break;
    case 'ro':
      var variantText = "Variantă: ";
      break;
    case 'bg':
      var variantText = "Variant: ";
      break;
    case 'hr':
      var variantText = "Varijanta: ";
      break;
    case 'si':
      var variantText = "Različica: ";
      break;
     case 'ua':
      var variantText = "Variant: ";
      break; 
    default:
      return;
  }
  switch(shopName) {
    case 'wsk':
      var sizeOption = $('#parameter-id-245 option:selected');
      break;
    case 'whu':
      var sizeOption = $('#parameter-id-245 option:selected');
      break;
    case 'wcz':
      var sizeOption = $('#parameter-id-28 option:selected');
      break;
    //testovaci e-shop
    case 'test':
      var sizeOption = $('#parameter-id-28 option:selected');
      break;
    default:
      return;
  }

  if(!sizeOption || !sizeOption.val()) {
    $('.basic-description ul li:hidden').show();
    return;
  }
  var parentUl = $('.basic-description ul li:contains("' + variantText + sizeOption.text() + '")').closest('ul');
  if(parentUl.length) {
    parentUl.find('> li').hide();
    parentUl.find('> li:contains("' + variantText + sizeOption.text() + '")').show();
  }
}

function upsellGrateCartUpdate() {
  if (!$('#upsell-rost').length) {
    return;
  }

  switch(lang) {
    case 'sk':
      var headlineText = 'Aby bola posteľ kompletná, <br>odporúčame dokúpiť <strong>rošt</strong> a <strong>matrac</strong>';
      var variantText = "Variant: ";
      break;
    case 'hu':
      var headlineText = 'Azért, hogy az ágy komplett legyen, <strong>matrac</strong> és <strong>ágyrács</strong> vásárlását javasoljuk.';
      var variantText = "Változat: ";
      break;
    case 'cs':
      var headlineText = 'Aby bylo lůžko kompletní,<br>doporučujeme zakoupit <strong>rošt</strong> a <strong>matraci</strong>';
      var variantText = "Varianta: ";
      break;
    case 'ro':
      var headlineText = 'Pentru ca patul să fie complet,<br>recomandăm să achiziționați <strong>somiera</strong> și <strong>saltea</strong>';
      var variantText = "Variantă: ";
      break;
    case 'bg':
      var headlineText = 'Aby bola posteľ kompletná, <br>odporúčame dokúpiť <strong>rošt</strong> a <strong>matrac</strong>';
      var variantText = "Variant: ";
      break;
    case 'hr':
      var headlineText = 'Kako bi krevet bio potpun, <br>opreporučujemo kupnju <strong>podnice</strong> i <strong>madraca</strong>';
      var variantText = "Varijanta: ";
      break;
    case 'si':
      var headlineText = 'Da bo postelja popolna, <br>priporočamo nakup <strong>posteljnega dna</strong> in <strong>vzmetnice</strong>';
      var variantText = "Različica: ";
      break;
    case 'ua':
      var headlineText = 'Aby bola posteľ kompletná, <br>odporúčame dokúpiť <strong>rošt</strong> a <strong>matrac</strong>';
      var variantText = "Variant: ";
      break;
    default:
      return;
  }
  switch(shopName) {
    case 'wsk':
      var size = $('#parameter-id-245 option:selected').text();
      break;
    case 'whu':
      var size = $('#parameter-id-245 option:selected').text();
      break;
    case 'wcz':
      var size = $('#parameter-id-28 option:selected').text();
      break;
    //testovaci e-shop
    case 'test':
      var size = $('#parameter-id-28 option:selected').text();
      break;
    default:
      return;
  }

  var links = $('.basic-description ul li:contains("' + variantText + size + '") a');
  var htmlContent = "";
  if (links.length) {
    htmlContent = '<div class="grateBox-cart"><h2>' + headlineText + '</h2>' + '<div class="upsell-links">';

    links.each(function (index) {
      htmlContent = htmlContent + '<a href="' + $(this).attr('href') + '">' + $(this).text() + '</a>';
    });

    htmlContent = htmlContent + '</div>' + '</div>';
    $(htmlContent).insertAfter($(document).find('#cboxLoadedContent .advanced-order .extras-wrap'));
  }
}